<mat-expansion-panel class="af-panel">
  <mat-expansion-panel-header>
    <mat-panel-title class="af-panel-title">
      <mat-icon class="af-icon">sync_alt</mat-icon>
      <span>Auto-Forwarding</span>
    </mat-panel-title>
    <mat-panel-description>
      <span *ngIf="!loading && rule?.active"  class="af-badge af-badge--active">Active</span>
      <span *ngIf="!loading && rule && !rule.active" class="af-badge af-badge--inactive">Inactive</span>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <!-- Loading -->
  <div *ngIf="loading" class="af-loading">
    <mat-progress-spinner diameter="22" mode="indeterminate"></mat-progress-spinner>
  </div>

  <ng-container *ngIf="!loading">
    <!-- Error -->
    <p *ngIf="error" class="af-error">{{ error }}</p>

    <!-- No rule -->
    <div *ngIf="!rule" class="af-empty">
      <p class="af-empty-text">No auto-forwarding rule configured for this patient.</p>
      <button mat-stroked-button color="primary" (click)="openConfigureDialog()">
        <mat-icon>add</mat-icon> Configure
      </button>
    </div>

    <!-- Rule exists -->
    <ng-container *ngIf="rule">
      <div class="af-detail-row">
        <span class="af-label">Destination</span>
        <span class="af-value">{{ destinationFacilityName || rule.destinationSpokeId }}</span>
      </div>
      <div class="af-detail-row">
        <span class="af-label">Status</span>
        <span [class]="rule.active ? 'af-value af-text--active' : 'af-value af-text--inactive'">
          {{ rule.active ? 'Active' : 'Inactive' }}
        </span>
      </div>
      <div *ngIf="recentJobs.length > 0" class="af-detail-row">
        <span class="af-label">Last 30 days</span>
        <span class="af-value">{{ sentCount }} sent · {{ failedCount }} failed</span>
      </div>

      <div class="af-actions">
        <button mat-stroked-button color="primary" (click)="openConfigureDialog()">
          <mat-icon>settings</mat-icon> Configure
        </button>
        <button *ngIf="rule.active"
                mat-stroked-button
                color="warn"
                [disabled]="disabling"
                (click)="onDisable()">
          <mat-icon>pause_circle_outline</mat-icon> Disable
        </button>
      </div>

      <!-- Failed jobs -->
      <div *ngIf="failedJobs.length > 0" class="af-failed-section">
        <p class="af-failed-title">Failed transfers</p>
        <div *ngFor="let job of failedJobs" class="af-job-row">
          <div class="af-job-info">
            <code class="af-job-uid">{{ truncateUid(job.studyInstanceUid) }}</code>
            <span *ngIf="job.errorCode" class="af-error-code">{{ job.errorCode }}</span>
            <span class="af-retry-count">{{ job.retryCount }}/{{ job.maxRetries }}</span>
          </div>
          <button mat-icon-button
                  matTooltip="Retry transfer"
                  [disabled]="!!retryingJobId"
                  (click)="onRetry(job)">
            <mat-icon>replay</mat-icon>
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</mat-expansion-panel>
